import { render, staticRenderFns } from "./retangInc.vue?vue&type=template&id=2b8ae303&scoped=true"
import script from "./retangInc.vue?vue&type=script&lang=js"
export * from "./retangInc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8ae303",
  null
  
)

export default component.exports